// extracted by mini-css-extract-plugin
export default {"container":"scroll-arrow_container__pMKcI","jump":"scroll-arrow_jump__K2kgU"};